import { useContext } from 'react';
import { AuthContext, MenuContext } from '@monash/portal-frontend-common';
import {
  Icon,
  Route,
  Sidebar,
  SidebarContainer,
  SidebarItem,
  SidebarSection,
  SidebarItemSwitch,
} from '@monash/portal-react';
import SlideOutWrapper from '../common/slide-out/SlideOutWrapper';
import AllLinks from './all-links/AllLinksAdmin';
import ACCESS_ROLES from '../../constants/user-roles';
import Categories from './categories/Categories';
import LinksArchives from './links-archives/LinksArchives';

const Links = ({ root }) => {
  const { menu, handleMenu, closeMenu, menuRef, size } =
    useContext(MenuContext);

  const authCtx = useContext(AuthContext);

  const hasLinksAccess = [
    ACCESS_ROLES.ADMIN,
    ACCESS_ROLES.SUPPORT_DEVELOPER,
    ACCESS_ROLES.LINKS_ADMIN,
    ACCESS_ROLES.LINKS_DRAFT,
  ].some((x) => authCtx?.user?.roles?.includes(x));

  const withSidebar = (content) => (
    <SidebarContainer onLeft={true}>
      <Sidebar
        title="Admin"
        ifMenu={menu}
        toggleMenu={handleMenu}
        closeMenu={closeMenu}
        size={size}
        menuRef={menuRef}
      >
        <SidebarSection title="Managing for">
          <SidebarItemSwitch text="Links" linkTo="/" />
        </SidebarSection>
        <SidebarSection title="Boards">
          {hasLinksAccess && (
            <SidebarItem
              linkTo="apps/links/links"
              text="Links"
              icon={<Icon.Link />}
              onMenu={closeMenu}
            />
          )}
          {hasLinksAccess && (
            <SidebarItem
              linkTo="apps/links/categories"
              text="Categories"
              icon={<Icon.Layout2 />}
              onMenu={closeMenu}
            />
          )}
          {hasLinksAccess && (
            <SidebarItem
              linkTo="apps/links/archives"
              text="Archives"
              icon={<Icon.Box />}
              onMenu={closeMenu}
            />
          )}
        </SidebarSection>
      </Sidebar>
      <SlideOutWrapper>{content}</SlideOutWrapper>
    </SidebarContainer>
  );

  return (
    <>
      <Route to={`${root}/links`} exact>
        {withSidebar(<AllLinks />)}
      </Route>
      <Route to={`${root}/categories`} exact>
        {withSidebar(<Categories />)}
      </Route>
      <Route to={`${root}/archives`} exact>
        {withSidebar(<LinksArchives />)}
      </Route>
    </>
  );
};

export default Links;
